module.exports = __webpack_public_path__ + "static/media/Authentication-icon2.d84099fe.svg";